module.exports = __webpack_public_path__ + "static/thumb-posadas-f728bf01ceb07dfe80ed94ed62bc16fc.jpg";